module.exports = __webpack_public_path__ + "static/media/Warlock.b84f5dac.png";